export const PAGE_SIZE = 3;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
